import React from "react";
import styles from "./EventsSection.module.scss";
import Title from "components/title/Title";
import EventCard from "components/cards/eventCard/EventCard";

const EventsSection = () => {
  return (
    <div className={styles.eventsSectionContainer}>
      <div className="container">
        <Title text={"Events"} bottomStrokeWidth={"62%"} />
        <div className={styles.eventsList}>
          <EventCard />
          <EventCard />
          <EventCard />
        </div>
      </div>
    </div>
  );
};

export default EventsSection;
